import React, { useState, useEffect } from "react";
import axios from "axios";
import { showSuccess } from "services/toast.service";
import { handleError, getAccessToken } from "utils";
import { useHistory, useLocation } from "react-router-dom";
import Button from "components/Button";
import { API_BASE_URL } from "config/constants";
import Modal from "react-modal";

// components

export default function AddAnalytics({ color }) {
  const history = useHistory();
  const { pathname, state } = useLocation();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [manager, setmanager] = useState([]);

  const [assignedManager, setassignedManager] = useState({
    assign: "",
  });
  const [gettingData, setGettingData] = useState(false);

  const { data } = state || {};
  const isUpdate = pathname === "/admin/update-analytic";

  if (isUpdate && !data) {
    history.goBack();
  }
  const [approveid, setapproveid] = useState();

  const [allWebsites, setAllWebsites] = useState([]);
  const [submitClick, setSubmitClick] = useState(false);
  const [loading, setLoading] = useState(false);
  const [analytics, setAnalytics] = useState(
    data || {
      inventoryName: "",
      date: "",
      adRequests: "",
      matchedRequests: "",
      clicks: "",
      impressions: "",
      grossRevenue: "",
      ctr: "",
      cpm: "",
    }
  );

  const onChange = (e) => {
    console.log(e.target.value);
    setAnalytics({ ...analytics, [e.target.name]: e.target.value });
  };

  const isValid = () => {
    if (
      !analytics.inventoryName ||
      !analytics.date ||
      !analytics.adRequests ||
      !analytics.matchedRequests ||
      !analytics.clicks ||
      !analytics.impressions ||
      !analytics.grossRevenue
    )
      return false;
    return true;
  };

  const handleClick = () => {
    setSubmitClick(true);
    if (!isValid()) return;
    if (isUpdate) {
      updateClient(analytics);
    } else {
      addAnalytic(
        analytics.inventoryName,
        analytics.date,
        analytics.adRequests,
        analytics.matchedRequests,
        analytics.clicks,
        analytics.impressions,
        analytics.grossRevenue,
        analytics.ctr,
        analytics.cpm
      );
    }
  };

  const onapp = (e) => {
    setassignedManager({ ...assignedManager, [e.target.name]: e.target.value });
  };

  const getManagers = async () => {
    try {
      setGettingData(true);
      const response = await axios.get(
        `${API_BASE_URL}/user/all_account_managers`,
        {
          method: "GET",
          headers: {
            authorization: getAccessToken(),
          },
        }
      );
      setGettingData(false);
      const apiData = response.data;
      setmanager(apiData.result.data);
    } catch (error) {
      setGettingData(false);
      handleError(error);
    }
  };

  console.log(manager);
  useEffect(() => {
    getManagers();
  }, []);

  const addAnalytic = async (
    inventoryName,
    date,
    adRequests,
    matchedRequests,
    clicks,
    impressions,
    grossRevenue,
    ctr,
    cpm
  ) => {
    try {
      setLoading(true);
      const inventory = JSON.parse(inventoryName);
      const response = await axios.post(
        `${API_BASE_URL}/analytic`,
        {
          inventoryName: inventory.name,
          date,
          adRequests,
          matchedRequests,
          clicks,
          impressions,
          grossRevenue,
          ctr,
          cpm,
          assignedTo: inventory.assignedTo,
          assignedToId: inventory.assignedToId,
          userId: inventory.userId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: getAccessToken(),
          },
        }
      );
      setLoading(false);
      showSuccess(response?.data?.result?.message);
      history.push("/admin/analytics");
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const updateClient = async (dataToUpdate) => {
    try {
      setLoading(true);
      const response = await axios.put(
        `${API_BASE_URL}/analytic`,
        {
          id: data._id,
          ...dataToUpdate,
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: getAccessToken(),
          },
        }
      );
      setLoading(false);
      showSuccess(response?.data?.result?.message);
      history.push("/admin/analytics");
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const getAllWebsites = async () => {
    const response = await axios.get(`${API_BASE_URL}/website/all_websites`, {
      headers: {
        "Content-Type": "application/json",
        authorization: getAccessToken(),
      },
    });
    setAllWebsites(response?.data?.result?.data?.result);
  };

  useEffect(() => {
    getAllWebsites();
  }, []);

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
        <div className="rounded-t bg-white mb-0 px-6 py-6">
          <div className="text-center flex justify-between">
            <h6 className="text-blueGray-700 text-xl font-bold">
              {isUpdate ? "Update Analytic" : "Add New Analytic"}
              <span className="text-blueGray-700 text-sm font-bold">
                {" "}
                (Fill in the details below)
              </span>
            </h6>
          </div>
        </div>
        <div className="flex-auto px-4 py-10 pt-0">
          <form>
            <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase px-4">
              Analytics Information
            </h6>

            <div className="flex flex-wrap">
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Website Name
                  </label>

                  {isUpdate ? (
                    <div
                    className="block uppercase text-md  text-emerald-800 font-bold mt-2"
                    >{analytics.inventoryName}</div>
                  ) : (
                    <>
                      {" "}
                      <select
                        onChange={onChange}
                        name="inventoryName"
                        value={analytics.inventoryName}
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      >
                        <option value="" selected>
                          Choose
                        </option>
                        {allWebsites.map((e, index) => (
                          <option key={index} value={JSON.stringify(e)}>
                            {e.name}
                          </option>
                        ))}
                      </select>
                      {submitClick && !analytics.inventoryName && (
                        <div className="text-red-500 text-sm mt-1 font-semibold">
                          Website Name is required!
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Date
                  </label>
                  <input
                    type="date"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    value={analytics.date}
                    name="date"
                    onChange={onChange}
                  />
                  {submitClick && !analytics.date && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      Date is required!
                    </div>
                  )}
                </div>
              </div>
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Ad Requests
                  </label>
                  <input
                    type="number"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    value={analytics.adRequests}
                    name="adRequests"
                    onChange={onChange}
                  />
                  {submitClick && !analytics.adRequests && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      Ad Requests is required!
                    </div>
                  )}
                </div>
              </div>
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Matched Requests
                  </label>
                  <input
                    type="number"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    value={analytics.matchedRequests}
                    name="matchedRequests"
                    onChange={onChange}
                  />
                  {submitClick && !analytics.matchedRequests && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      Matched Requests is required!
                    </div>
                  )}
                </div>
              </div>

              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Clicks
                  </label>
                  <input
                    type="number"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    value={analytics.clicks}
                    name="clicks"
                    onChange={onChange}
                  />
                  {submitClick && !analytics.clicks && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      Clicks is required!
                    </div>
                  )}
                </div>
              </div>

              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    CTR
                  </label>
                  <input
                    type="number"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    value={analytics.ctr}
                    name="ctr"
                    onChange={onChange}
                  />
                  {submitClick && !analytics.ctr && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      CTR is required!
                    </div>
                  )}
                </div>
              </div>

              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Ad Impressions
                  </label>
                  <input
                    type="number"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    value={analytics.impressions}
                    name="impressions"
                    onChange={onChange}
                  />
                  {submitClick && !analytics.impressions && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      Ad Impressions is required!
                    </div>
                  )}
                </div>
              </div>

              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Revenue
                  </label>
                  <input
                    type="number"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    value={analytics.grossRevenue}
                    name="grossRevenue"
                    onChange={onChange}
                  />
                  {submitClick && !analytics.grossRevenue && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      Revenue is required!
                    </div>
                  )}
                </div>
              </div>

              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    CPM
                  </label>
                  <input
                    type="number"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    value={analytics.cpm}
                    name="cpm"
                    onChange={onChange}
                  />
                  {submitClick && !analytics.cpm && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      CPM is required!
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="px-4">
              <Button
                title={isUpdate ? "UPDATE ANALYTIC" : "ADD NEW ANALYTIC"}
                handleClick={handleClick}
                loading={loading}
              />
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
